import React, { Component } from 'react';
import PropTypes from 'prop-types';

/** Components */
import StyledThumbnail from './styledThumbnail';

import { getCrop } from '../../../utils/crops';

/** Constants */
const defaultCrop = { height: 128, width: 128 };

class Thumbnail extends Component {
  constructor() {
    super();
    this.state = {
      isError: false
    };
  }

  onImageError = () => {
    this.setState({ isError: true });
  };

  render() {
    const { path, alt } = this.props;
    const { isError } = this.state;

    return (
      !isError && (
        <StyledThumbnail
          src={getCrop({ path, crop: defaultCrop, format: 'jpg' })}
          alt={alt}
          onError={this.onImageError}
        />
      )
    );
  }
}

Thumbnail.defaultProps = {
  path: undefined,
  alt: ''
};

Thumbnail.propTypes = {
  path: PropTypes.string,
  alt: PropTypes.string
};

export default Thumbnail;
